var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleDownSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06261 5.33315C3.16395 5.12907 3.37215 5 3.6 5H12.4C12.6279 5 12.836 5.12907 12.9374 5.33315C13.0387 5.53723 13.0157 5.7811 12.878 5.96263L8.47802 11.7627C8.36458 11.9122 8.1877 12 8 12C7.81231 12 7.63543 11.9122 7.52199 11.7627L3.12199 5.96263C2.98428 5.7811 2.96127 5.53723 3.06261 5.33315ZM4.80829 6.2L8 10.4073L11.1917 6.2H4.80829Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDownSmall);
export default __webpack_public_path__ + "static/media/triangle-down-small.017a07fd96281a3024c8e87986c4974d.svg";
export { ForwardRef as ReactComponent };